
<div id="subheader" class="content-sub-header">
    <div class="left-content">
        <img class="title-img" src="../../../../assets/images/{{menuIcon}}.svg">
        <p class="title-text">{{title}}</p>
    </div>
    <div class="d-flex align-items-center">
        <caremoni-ui-theme *ngIf="isShowUITheme"></caremoni-ui-theme>
        <div *ngIf="isShowExpand" [attr.dpad]="DpadZoneType.SUB_HEADER"  y-dpad="0" x-dpad="1"  class="expand" (click)="onExpand()"></div>
    </div>
</div>